import { Input } from '@/components/ui/Input';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

interface RangeInputProps {
  minValue?: number | null;
  maxValue?: number | null;
  onMinChange: (value: number | null) => void;
  onMaxChange: (value: number | null) => void;
  minLabel?: string;
  maxLabel?: string;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  step?: number;
  prefix?: string;
  className?: string;
  disabled?: boolean;
}

export function RangeInput({
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  minLabel,
  maxLabel,
  minPlaceholder,
  maxPlaceholder,
  step = 1,
  prefix,
  className,
  disabled = false,
}: RangeInputProps) {
  const { t } = useTranslation();

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onMinChange(val === '' ? null : Number(val));
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onMaxChange(val === '' ? null : Number(val));
  };

  return (
    <div className={`grid grid-cols-2 gap-4 ${className || ''}`}>
      <div className="space-y-2">
        <Label>{minLabel || t('common.min')}</Label>
        <div className="relative">
          {prefix && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">
              {prefix}
            </span>
          )}
          <Input
            type="number"
            value={minValue ?? ''}
            onChange={handleMinChange}
            placeholder={minPlaceholder}
            step={step}
            disabled={disabled}
            className={prefix ? 'pl-8' : ''}
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label>{maxLabel || t('common.max')}</Label>
        <div className="relative">
          {prefix && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">
              {prefix}
            </span>
          )}
          <Input
            type="number"
            value={maxValue ?? ''}
            onChange={handleMaxChange}
            placeholder={maxPlaceholder}
            step={step}
            disabled={disabled}
            className={prefix ? 'pl-8' : ''}
          />
        </div>
      </div>
    </div>
  );
}
